import { render } from "./TheFooterEmailList.vue?vue&type=template&id=22887da1"
import script from "./TheFooterEmailList.vue?vue&type=script&lang=js"
export * from "./TheFooterEmailList.vue?vue&type=script&lang=js"
script.render = render

export default script